module.exports = __webpack_public_path__ + "img/Oelsnitz-media.3aef7131.jpg";